import React from 'react'
import Layout from '../Components/Layout'
import First from '../Components/Home/First';
import Second from '../Components/Home/Second';
import Third from '../Components/Home/Third';
import Fourth from '../Components/Home/Fourth';
import Fifth from '../Components/Home/Fifth';
import Sixth from '../Components/Home/Sixth';
import Seventh from '../Components/Home/Seventh';
import Eight from '../Components/Home/Eight';
import Nineth from '../Components/Home/Nineth';
import Tenth from '../Components/Home/Tenth';
import Eleven from '../Components/Home/Eleven';
import Twelve from '../Components/Home/Twelve';
import Thirteenth from '../Components/Home/Thirteenth';
import Tours from '../Components/Home/Tours';

const Index = () => {

  return (
    <Layout>
        <First /> 

        <Third />

        <Second />

        {/* <Tours /> */}

        <Seventh />

        <Fourth />

        <Eight />

        <Nineth />
        
        <Tenth />

        <Eleven />

        <Thirteenth />
    </Layout>
    );
};
export default Index;